<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="start"><span><a id="dedication"><i>To Charles Tucker</i></a></span></p><a id="dedication">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-start.vue?671c5504